<template>
  <div>
    <div class="title">
      网页title设置：{{ title }}
      <el-button type="primary" size="mini" @click="editSummary(title, 0, 500)"
        >编辑</el-button
      >
    </div>
    <div class="head"><img src="@/assets/image/home/search-head.png" alt="" /></div>
    <div class="body_warp">
      <div class="left">
        <img src="@/assets/image/home/search-left.png" alt="" />
      </div>
      <div class="right">
        <div class="advert">
          <img :src="$utils.fileUrl(advert01.imageUrl)" alt="" />
          <span class="tips">图片尺寸：270*200px 格式：jpg、png</span>
          <el-button type="primary" size="mini" @click="editAdver(advert01, 1)">
            更换
          </el-button>
          <input type="file" id="advert01" />
        </div>
        <div class="advert">
          <img :src="$utils.fileUrl(advert02.imageUrl)" alt="" />
          <span class="tips">图片尺寸：270*200px 格式：jpg、png</span>
          <el-button type="primary" size="mini" @click="editAdver(advert02, 2)">
            更换
          </el-button>
          <input type="file" id="advert01" />
        </div>
        <img src="@/assets/image/home/search-right.png" alt="" />
      </div>
    </div>

    <!-- 广告 -->
    <el-dialog
      v-model="advert_dialog"
      title="编辑广告"
      width="500px"
      destroy-on-close
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <div>
        <el-form
          :model="advertForm"
          :rules="advertRules"
          size="mini"
          ref="advertForm"
          label-width="80px"
          label-position="right"
        >
          <el-form-item label="图片：" prop="imageUrl">
            <label
              class="upload-advert"
              for="file"
              :style="
                advertForm.imageUrl
                  ? `background-image: url(${$utils.fileUrl(
                      advertForm.imageUrl
                    )})`
                  : ''
              "
            >
              <i class="el-icon-plus" v-if="!advertForm.imageUrl"></i>
              <input type="file" id="file" @change="upload(5, $event)" />
            </label>
          </el-form-item>
          <el-form-item label="链接：" prop="imageLink">
            <el-input
              placeholder="链接"
              maxlength="500"
              show-word-limit
              v-model="advertForm.imageLink"
            ></el-input>
          </el-form-item>
          <el-form-item label="简介：">
            <el-input
              rows="5"
              resize="none"
              type="textarea"
              placeholder="简介"
              maxlength="500"
              show-word-limit
              v-model="advertForm.imageExplain"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="advert_dialog = false" size="mini">取消</el-button>
          <el-button @click="submit_advert" type="primary" size="mini"
            >确认</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      advert01: {},
      advert02: {},
      title: "",
      advert_dialog: false,
      advertForm: {
        imageUrl: "",
        imageExplain: "",
        imageLink: "",
        pageLocation: null,
      },

      advertRules: {
        imageUrl: [
          { required: true, message: "请选择广告图片", trigger: "change" },
        ],
        imageLink: [
          {
            required: false,
            pattern: /(http|https):\/\/([\w.]+\/?)\S*/,
            message: "格式不正确",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    async getData() {
      try {
        const res = await this.$api.pageManage.getData(2);
        if (res.code === 10200) {
          this.advert01 = res.data.advert01;
          this.advert02 = res.data.advert02;
          this.title = res.data.webTitle.content;
        } else {
          this.$message.error(res.msg);
        }
      } catch (err) {}
    },
    // 编辑概述
    editSummary(content, type, limit = 30) {
      this.$prompt("请输入内容", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputValue: content,
        inputValidator: (value) => {
          if (!value) return "请输入内容";
          else if (value.length > limit) return `最多输入${limit}个字符`;
          else return true;
        },
      })
        .then(({ value }) => {
          const params = {
            content: value,
            pageType: 2,
            pageLocation: type,
          };
          this.setSummary(params);
        })
        .catch(() => {});
    },
    // 保存概述
    async setSummary(params) {
      if (!this.loading) {
        try {
          this.loading = true;
          this.$loading.start();
          const res = await this.$api.pageManage.setSummary(params);
          this.loading = false;
          this.$loading.done();
          if (res.code === 10200) {
            this.getData();
            this.$message.success("保存成功");
          } else {
            this.$message.error(res.msg);
          }
        } catch (error) {
          this.loading = false;
          this.$loading.done();
        }
      }
    },
    upload(type, e, index) {
      e = e.target || e.srcElement;
      const files = e.files[0];
      if (e.value == "") {
        return;
      }

      let args = files.name.split(".");
      let nameType = args[args.length - 1];
      const fileType = ["jpg", "png"];

      if (fileType.indexOf(nameType) < 0) {
        this.$message.warning(`不支持上传${nameType}格式的文件`);
        return;
      }

      if (!this.loading) {
        this.loading = true;
        this.$loading.start();
        this.$api
          .uploadFile(type, files)
          .then((res) => {
            this.$message.success("上传成功");
            e.value = "";
            this.$loading.done();
            this.loading = false;
            this.advertForm.imageUrl = res;
          })
          .catch((err) => {
            e.value = "";
            this.$loading.done();
            this.loading = false;
          });
      }
    },
    editAdver(data, type) {
      this.advertForm.imageUrl = data.imageUrl;
      this.advertForm.imageLink = data.imageLink;
      this.advertForm.imageExplain = data.imageExplain;
      this.advertForm.pageLocation = type;
      this.advert_dialog = true;
    },
    submit_advert() {
      this.$refs["advertForm"].validate((valid) => {
        if (valid) {
          this.set_advert();
        } else {
          return false;
        }
      });
    },
    // 提交编辑广告
    async set_advert() {
      if (!this.loading) {
        try {
          this.loading = true;
          this.$loading.start();
          const params = {
            ...this.advertForm,
            pageType: 2,
          };
          const res = await this.$api.pageManage.setAdvert(params);
          this.$loading.done();
          this.loading = false;
          if (res.code === 10200) {
            this.advert_dialog = false;
            this.getData();
            this.$message.success("保存成功！");
          } else {
            this.$message.error(res.msg);
          }
        } catch (err) {
          this.$loading.done();
          this.loading = false;
        }
      }
    },
  },
  created() {
    this.getData();
  },
};
</script>

<style lang="scss" scoped>
.title {
  padding: 24px;
  font-size: 0.875rem;
  margin-bottom: 24px;
  background-color: #ffffff;

  .el-button {
    margin-left: 40px;
  }
}
.head {
  img {
    width: 100%;
  }
}
.body_warp {
  max-width: 1400px;
  display: flex;
  margin: 0 auto;
  .left {
    flex: 1;
    margin-right: 150px;
    img {
      width: 100%;
    }
  }
  .right {
    width: 370px;

    .advert {
      width: 270px;
      display: flex;
      min-height: 200px;
      position: relative;
      margin-bottom: 15px;
      align-items: flex-start;
      border: 1px solid $--color-danger;

      .tips {
        top: 20px;
        left: 20px;
        z-index: 9;
        padding: 3px 10px;
        position: absolute;
        font-size: 0.75rem;
        background-color: $--color-warning;
      }
      img {
        width: 100%;
      }

      input {
        display: none;
      }

      .el-button {
        left: 20px;
        bottom: 20px;
        width: 100px;
        position: absolute;
      }
    }

    & > img {
      width: 100%;
    }
  }
}

.upload-advert {
  width: 100px;
  height: 100px;
  cursor: pointer;
  line-height: 100px;
  text-align: center;
  display: inline-block;
  box-sizing: border-box;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border: 1px solid $--border-color-base;
  input {
    display: none;
  }
}
</style>